import React from 'react';
import { Eyebrow, Section } from './Section';
import { TestimonialSlot } from '../data/testimonials';
interface TestimonialsProps {
  slots: TestimonialSlot[];
  eyebrow: string;
  title: string;
  note: string;
  tone?: 'creme' | 'paper';
  id: string;
}
export function Testimonials({
  slots,
  eyebrow,
  title,
  note,
  tone = 'paper',
  id
}: TestimonialsProps) {
  return <Section tone={tone} labelledBy={`${id}-title`} data-id="element-231" data-mp="36yzg4rqg7cp0">
      <Eyebrow data-id="element-232" data-mp="370kbgjkl6znx">{eyebrow}</Eyebrow>
      <h2 id={`${id}-title`} className="max-w-3xl font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.5rem]" data-id="element-233" data-mp="36wmqrtid201x">
        {title}
      </h2>
      <p className="mt-5 max-w-prose text-sm leading-relaxed text-warm" data-id="element-234" data-mp="2x2w2opq5brmr">
        {note}
      </p>

      <ul className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-235" data-mp="2s3t8k0bpf5tk">
        {slots.map(slot => <li key={slot.theme} className="flex flex-col border border-dashed border-warm-line bg-creme/60 p-6" data-id="element-236" data-mp="v7c9be7wbjt3">
            <p className="text-[0.68rem] font-semibold uppercase tracking-[0.14em] text-warm-light" data-id="element-237" data-mp="h5ornglmyga2">
              Emplacement à compléter
            </p>
            <h3 className="mt-4 font-serif text-lg font-semibold leading-snug text-graphite" data-id="element-238" data-mp="m2ydyndqabto">
              {slot.theme}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-graphite-mid" data-id="element-239" data-mp="c6buo311vstr">
              {slot.brief}
            </p>
            <p className="mt-auto pt-8 text-xs leading-relaxed text-warm" data-id="element-240" data-mp="zxhawjawkn4l">
              {slot.attribution}
            </p>
          </li>)}
      </ul>
    </Section>;
}